import { useStore } from "@store/index"

const useAvatarDataConnectorsGroup = (dataCategoryId: string) => {
  const { avatarDataConnectorsGroupsStore } = useStore()
  return avatarDataConnectorsGroupsStore.getCollection(dataCategoryId)
}

export default useAvatarDataConnectorsGroup
